
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calls",
      function () {
        return require("private-next-pages/calls/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calls"])
      });
    }
  